import { getTimezoneOffset, utcToZonedTime } from 'date-fns-tz';
import { addMilliseconds, subMilliseconds, fromUnixTime } from 'date-fns';

const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
/**
 * przelicza czas UTC na relatywny odpowiednik lokalnego czasu
 * np. 00:00:00 1.01.01 UTC  na 03:00:00 1.01.01 GTM +3
 */

export function relativeUtcToLocalTime(date) {
  const offset = getTimezoneOffset(TIMEZONE, date);
  return subMilliseconds(date, offset);
}

/**
 * przelicza lokalny czas na relatywny odpowiednik UTC
 * np. 00:00:00 1.01.01 GMT+3  na 03:00:00 1.01.01 UTC
 */
export function localTimetoRelativeUTC(date) {
  const offset = getTimezoneOffset(TIMEZONE, date);
  const converted = addMilliseconds(date, offset);
  return converted;
}

export function gmtTimestampToLocalDate(timestamp) {
  const ts = timestamp > 1e12 ? Math.floor(timestamp / 1000) : timestamp;
  const date = new Date(ts * 1000);

  // date-only w strefie lokalnej
  date.setHours(0, 0, 0, 0);
  return date;
}

export function localDateToGmtTimestamp(localDate) {
  if (!localDate) return localDate;

  // Jeśli już jest timestampem — zwróć w sekundach, bez konwersji
  if (typeof localDate === 'number' && Number.isFinite(localDate)) {
    return localDate > 1e12
      ? Math.floor(localDate / 1000)
      : Math.floor(localDate);
  }

  if (!(localDate instanceof Date) || Number.isNaN(localDate.getTime())) {
    return null;
  }

  // date-only: wysyłamy 00:00:00 UTC dla wybranego dnia kalendarzowego
  return Math.floor(
    Date.UTC(
      localDate.getFullYear(),
      localDate.getMonth(),
      localDate.getDate(),
      0,
      0,
      0,
      0,
    ) / 1000,
  );
}

export function normalizeDateFromApiWithoutTimeCorrection(timestamp) {
  // Jeśli timestamp jest w milisekundach, zamień na sekundy
  const ts = timestamp > 1e12 ? Math.floor(timestamp / 1000) : timestamp;
  const date = fromUnixTime(ts); // UTC
  return utcToZonedTime(date, TIMEZONE); // lokalna data
}

/* export function gmtTimestampToLocalDate(timestamp) {
  // Jeśli timestamp jest w milisekundach, zamień na sekundy
  const ts = timestamp > 1e12 ? Math.floor(timestamp / 1000) : timestamp;
  const date = fromUnixTime(ts); // UTC
  return utcToZonedTime(date, TIMEZONE); // lokalna data
}

export function localDateToGmtTimestamp(localDate) {
  // Zamień lokalną datę na UTC
  const utcDate = zonedTimeToUtc(localDate, TIMEZONE);
  // Zwróć timestamp w sekundach
  return Math.floor(utcDate.getTime() / 1000);
} */

export function normalizeDateFromApi(timestamp) {
  return gmtTimestampToLocalDate(timestamp);
}

export function normalizeDateForApi(date) {
  return localDateToGmtTimestamp(date);
}

export function parseDateFromApi(date) {
  return relativeUtcToLocalTime(Date.parse(date));
}

export function formatDateFromTimestamp(timestamp) {
  let date = normalizeDateFromApi(timestamp);
  return date.toLocaleDateString('pl-PL', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });
}
